<template>
    <div class="w-full">
        <div class="w-full flex flex-wrap mb-2">
            <div class="mr-3 flex items-center" v-for="(label, index) in data.labels">
                <div class="w-4 h-4 mr-2 rounded" :style="`background-color: ${data.datasets[0].backgroundColor[index]}`" />
                {{label}}
            </div>
        </div>
        <div class="flex w-full h-9 rounded overflow-hidden bg-white">
            <div v-for="(item, index) in data.datasets[0].data" class="flex justify-center items-center" :style="[`width: ${percentageValues[index]}%`, `background-color: ${data.datasets[0].backgroundColor[index]}`]">
                <span class="text-white font-black">{{item}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data: () => ({
        percentageValues: [],
    }),
    methods: {
        setPercentageValues() {
            const data = [...this.data.datasets[0].data];
            let totalValue = 0;
            data.forEach(item => {
                totalValue += item;
            });

            this.percentageValues = data.map(item => {
                return (item / totalValue) * 100
            });
        },
    },
    created() {
        this.setPercentageValues();
    }
}
</script>
